import React, { createContext, useContext, useEffect, useState } from "react";
import useStyles from "./styles";
import { styled, Tab, Tabs, Box, Stack } from "@mui/material";
import Summary from "./components/Summary";
import Milestones from "./components/Milestones";
import Budgets from "./components/Budgets";
import PaymentGroups from "./components/PaymentGroups";
import Review from "./components/Review";
import { useNavigate, useParams } from "react-router-dom";

const ProposalContext = createContext();

const StyledTabs = styled(Tabs)({
  display: "flex",
  gap: "10px",
  padding: "0",
});

const StyledTab = styled(Tab)(({ selected }) => ({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  padding: "1vh 1vw",
  borderRadius: "60px",
  fontFamily: "Inter Tight",
  fontWeight: 600,
  textTransform: "none",
  backgroundColor: selected ? "#0D0D0D" : "#F7F7F7",
  color: selected ? "#FFFFFF !important" : "#949DAA !important",
  transition: "all 0.3s ease-in-out",
  "&:hover": {
    backgroundColor: selected ? "#0D0D0D" : "#EDEDED",
    color: selected ? "#FFFFFF" : "#000",
  },
  marginRight: "10px",
}));

const TabNumber = styled("span")(({ selected }) => ({
  width: "28px",
  height: "32px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "60px",
  fontSize: "14px",
  fontWeight: 600,
  padding: "1vh 1vw",
  backgroundColor: selected ? "#3d3d3d" : "#FFFFFF",
  color: selected ? "#9e9e9e" : "#949DAA",
  border: "none !important",
}));
const tabRoutes = ["", "milestone", "budget", "payment-group", "review"];

function NewCreateProposal() {
  const { id, tab } = useParams();
  const [proposalDetails, setProposalDetails] = useState({});
  const navigate = useNavigate();
  const classes = useStyles();

  useEffect(() => {
    if (id) {
      setProposalDetails({ proposal_id: id });
    }
  }, [id]);

  useEffect(() => {
    if (tab && !tabRoutes.includes(tab)) {
      navigate(`/new-create-proposal/${id || ""}/${tabRoutes[0]}`, {
        replace: true,
      });
    }
  }, [id, tab, navigate]);

  const tabValue = tabRoutes.indexOf(tab || "");

  const handleTabChange = (event, newValue) => {
    const newTabRoute = tabRoutes[newValue]
      ? `/new-create-proposal/${id || ""}/${tabRoutes[newValue]}`
      : `/new-create-proposal/${id || ""}`;
    navigate(newTabRoute);
  };
  const modalStyle = {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    bgcolor: "background.paper",
    padding: "0 !important",
    overflow: "hidden",
    margin: "20px 0",
    height: "100%",
  };

  const renderSwitch = () => {
    switch (tabValue) {
      // case 0:
      //   return <Summary />;
      // case 1:
      //   return <Milestones />;
      // case 2:
      //   return <Budgets />;
      // case 3:
      //   return <PaymentGroups />;
      // case 4:
      //   return <Review />;
      default:
        return <Summary />;
    }
  };

  // Budget tab should be disabled if there are no milestones or if any milestone lacks a start & end date
  const handleBudgetDisabled = () => {
    return (
      !proposalDetails?.milestone?.length ||
      proposalDetails.milestone.some((m) => !m.start_date || !m.end_date)
    );
  };

  // Payment Groups tab should be disabled if Budget tab is disabled or if no milestone has a budget
  const handlePaymentGroupDisabled = () => {
    if (handleBudgetDisabled()) return true;

    return !proposalDetails?.milestone?.some(
      (milestone) =>
        Array.isArray(milestone.budget) && milestone.budget.length > 0
    );
  };

  // Review tab should be disabled if Payment Groups are disabled or if not all milestones are assigned to a group
  const handleReviewDisabled = () => {
    if (handlePaymentGroupDisabled()) return true;

    return !proposalDetails.milestone.every((milestone) =>
      proposalDetails.payment_groups?.some((group) =>
        group.milestones?.some((m) => m.id === milestone.id)
      )
    );
  };

  return (
    <ProposalContext.Provider value={{ proposalDetails, setProposalDetails }}>
      <div
        className={classes.container}
        style={{
          padding: "3vh 3vw 2vh 3vw",
          display: "flex",
          flexDirection: "column",
          flex: 1,
          backgroundColor: "#fff",
        }}
      >
        <Box sx={modalStyle}>
          {/* <Stack direction="row" justifyContent="space-between">
            <StyledTabs
              value={tabValue}
              variant="scrollable"
              onChange={handleTabChange}
              aria-label="Styled Tabs"
              sx={{
                "& .MuiTabs-indicator": {
                  background: "none",
                },
              }}
            >
              {tabRoutes.map((route, index) => (
                <StyledTab
                  key={index}
                  label={
                    <Box display="flex" alignItems="center" gap={1}>
                      <TabNumber selected={tabValue === index}>{`0${index + 1
                        }`}</TabNumber>
                      <span>
                        {route
                          ? route
                            .replace("-", " ")
                            .replace(/\b\w/g, (char) => char.toUpperCase())
                          : "Summary"}
                      </span>
                    </Box>
                  }
                  disabled={
                    (index === 1 &&
                      (!proposalDetails ||
                        Object?.keys(proposalDetails)?.length === 0)) ||
                    (index === 2 && handleBudgetDisabled()) ||
                    (index === 3 && handlePaymentGroupDisabled()) ||
                    (index === 4 && handleReviewDisabled())
                  }
                  sx={{
                    cursor:
                      (index === 1 &&
                        (!proposalDetails ||
                          Object.keys(proposalDetails).length === 0)) ||
                        (index === 2 && handleBudgetDisabled()) ||
                        (index === 3 && handlePaymentGroupDisabled()) ||
                        (index === 4 && handleReviewDisabled())
                        ? "not-allowed"
                        : "pointer",
                  }}
                />
              ))}
            </StyledTabs>
          </Stack> */}

          {renderSwitch()}
        </Box>
      </div>
    </ProposalContext.Provider>
  );
}
export default NewCreateProposal;

export const useProposalContext = () => useContext(ProposalContext);
